import { Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../pages";
import { SpecialistReferralContentTrustSection } from "./SpecialistReferralContentTrustSection/SpecialistReferralContentTrustSection";
import { SpecialistReferralContentWhileWaiting } from "./SpecialistReferralContentWhileWaiting/SpecialistReferralContentWhileWaiting";
import type { SpecialistReferralContentProps } from "./types";

export const SpecialistReferralContent = ({
  ref,
  ...props
}: WithMetadata<SpecialistReferralContentProps>) => {
  const {
    className,
    variant = "general",
    layout = "vertical",
    phoneNumbers,
    children,
    componentName,
    customerName,
    nextStepsDescription,
    zendeskData,
    ...otherProps
  } = props;

  const classes = classNames(
    "mobius",
    "mobius-specialist-referral-content",
    `mobius-specialist-referral-content--${layout}`,
    className,
  );

  return (
    <>
      <div
        ref={ref}
        {...otherProps}
        {...(componentName ? { "data-component": componentName } : {})}
        {...(variant ? { "data-variant": variant } : {})}
        {...(layout ? { "data-layout": layout } : {})}
        className={classes}
        data-testid="specialist-referral-content"
      >
        <div className="mobius-specialist-referral-content__content">
          <div className="mobius-specialist-referral-content__header">
            <Text
              elementType="h1"
              className="mobius-specialist-referral-content__title"
            >
              {customerName ? (
                <>
                  Thanks for telling us about your business{" "}
                  <strong className="has-pii">{customerName}</strong>
                  {", that\u2019s the hard bit done, now sit back and relax!"}
                </>
              ) : (
                "Thanks for telling us about your business, that\u2019s the hard bit done, now sit back and relax!"
              )}
            </Text>
          </div>

          <div className="mobius-specialist-referral-content__next-steps-main">
            <h2 className="mobius-specialist-referral-content__section-title">
              What happens next?
            </h2>
            <Text
              variant="body"
              className="mobius-specialist-referral-content__description"
            >
              {nextStepsDescription}
            </Text>
          </div>

          <SpecialistReferralContentWhileWaiting />
        </div>

        {children}
      </div>

      <SpecialistReferralContentTrustSection />
    </>
  );
};

SpecialistReferralContent.displayName = "SpecialistReferralContent";
